// @ts-ignore
import UrlParser from 'fast-url-parser';
import { logCustom } from "./tracker";
import { CnMessage } from "@alife/cn-ui";
import { event } from "@ice/stark-data";
import { MONITOR_KEY } from "./const";
export const getVaildEnv = (env) => {
    const envs = ['daily', 'pre', 'prod'];
    if (envs.indexOf(env) > -1) {
        return env;
    }
    return 'prod';
};
export function traverseEverJSON(jsonData, inCallback, outCallback) {
    if (Array.isArray(jsonData)) {
        // 数组第一位是tagName，第二位是props，第三位是children
        var tagName = jsonData[0];
        var props = jsonData[1] || {};
        var children = jsonData.slice(2);
        if (inCallback)
            inCallback(tagName, props, children);
        children.forEach(function (n) {
            if (Array.isArray(n)) {
                traverseEverJSON(n, inCallback, outCallback);
            }
        });
        if (outCallback)
            outCallback(tagName, props, children);
    }
}
/**
 * 对象转 search string
 * @param obj
 * @returns string
 */
export function qs(obj) {
    const urlInstance = new URLSearchParams();
    Object.keys(obj).forEach(key => {
        urlInstance.append(key, obj[key]);
    });
    return urlInstance.toString();
}
export function replaceContentByKeyword({ content, keyword, tag = 'span', className = 'one-search-box-highlight', }) {
    let hasHighlight = false;
    let html = content;
    const startString = `<${tag}  class="${className}">`;
    const endString = `</${tag}>`;
    const replaceKeyword = (content, keyword) => {
        let hasHighlight = false;
        let html = content;
        const newContent = content.split(keyword);
        if (newContent.length) {
            hasHighlight = true;
            html = newContent.join(`${startString}${keyword}${endString}`);
        }
        return {
            hasHighlight,
            html,
        };
    };
    if (content && keyword) {
        if (content.includes(startString) && content.includes(endString)) {
            const arr = [];
            let restContent = content;
            while (restContent) {
                let start = restContent.indexOf(startString);
                let end = restContent.indexOf(endString);
                if (start > -1 && end > -1) {
                    let endIndex = end + endString.length;
                    arr.push({
                        html: restContent.slice(start, endIndex),
                        done: true,
                    });
                    restContent = restContent.slice(endIndex);
                    let nextStart = restContent.indexOf(startString);
                    if (nextStart > 0) {
                        arr.push({
                            html: restContent.slice(0, nextStart),
                            done: false,
                        });
                    }
                }
                else {
                    arr.push({
                        html: restContent,
                        done: !restContent.includes(keyword),
                    });
                    restContent = '';
                }
            }
            let newHtml = '';
            // console.log('arr', arr, keyword);
            arr.forEach((item) => {
                if (!item.done) {
                    const res = replaceKeyword(item.html, keyword);
                    newHtml += res.html;
                    if (res.hasHighlight) {
                        hasHighlight = true;
                    }
                }
                else {
                    newHtml += item.html;
                }
            });
            return {
                html: newHtml,
                hasHighlight,
            };
        }
        else {
            const res = replaceKeyword(content, keyword);
            return res;
        }
    }
    return {
        html,
        hasHighlight,
    };
}
export function handleHighlightKeyword({ content, keywords, tag = 'span', className = 'one-search-box-highlight', }) {
    const keywordMap = {};
    keywords.forEach((val) => {
        if (!keywordMap[val.length]) {
            keywordMap[val.length] = [];
        }
        keywordMap[val.length].push(val);
    });
    const keyList = Object.keys(keywordMap)
        .map(Number)
        .sort((a, b) => (a < b ? 1 : -1));
    content = content.toString();
    let tempContent = content;
    let hasHighlight = false;
    keyList.forEach((key) => {
        let keywordList = keywordMap[key];
        keywordList.forEach((keyword) => {
            const res = replaceContentByKeyword({
                content: tempContent,
                keyword,
                tag,
                className,
            });
            tempContent = res.html;
            if (res.hasHighlight) {
                hasHighlight = true;
            }
        });
    });
    return {
        html: tempContent,
        hasHighlight,
    };
}
export const getDefer = () => {
    let defer = {};
    defer.promise = new Promise((resolve, reject) => {
        Object.assign(defer, { resolve, reject });
    });
    return defer;
};
export const execSlot = (slot, slotMsg, ...args) => {
    if (!slot)
        return null;
    logCustom('OTHER_exec-slot', slotMsg);
    if (typeof slot === 'function') {
        try {
            return slot(...args);
        }
        catch (error) {
            console.error(error, `exec ${slotMsg} fail`);
            return null;
        }
    }
    return slot;
};
export const matchPageByUrl = (url, pathname = location.pathname) => {
    const urls = (url?.split?.('\n') || []).filter(Boolean);
    let isEq = false;
    for (let i = 0; i < urls.length; i++) {
        const u = urls[i];
        const currentPathname = UrlParser.parse(u).pathname;
        if (currentPathname === pathname) {
            isEq = true;
            break;
        }
        if (currentPathname.endsWith('*') && pathname.startsWith(currentPathname.slice(0, -1))) {
            isEq = true;
            break;
        }
    }
    return isEq;
};
// 执行业务层自己的匹配逻辑
export const handleCustomMatchUrl = (url, pathname) => {
    try {
        // @ts-ignore
        const flag = window.cnIntelliAssistantFilterUrl?.(url);
        if (typeof flag === 'boolean') {
            return flag;
        }
    }
    catch (error) {
        console.error(error);
    }
    return matchPageByUrl(url, pathname);
};
export const getFormValue = (form) => {
    const val = {};
    Object.keys(form.fields).forEach((key) => {
        Object.keys(form.values).forEach((path) => {
            if (form.fields[key].match(path)) {
                val[path] = form.values[path];
            }
        });
    });
    return val;
};
export const isDailyAndHint = (hint) => {
    if (window._GATEWAY_PF?.env === 'daily') {
        CnMessage.warning('日常环境暂不支持' + (hint || ''));
        return true;
    }
    return false;
};
let isHiHack = false;
export const hookHistory = function () {
    const win = window;
    const monitorEvent = {
        on(fn) {
            event.on(MONITOR_KEY, fn);
        },
        off(fn) {
            event.off(MONITOR_KEY, fn);
        }
    };
    if (!(win && win.history && typeof win.history === 'object') || isHiHack) {
        return monitorEvent;
    }
    try {
        // hook onpopstate
        const oldPopstate = win.onpopstate;
        win.onpopstate = function (...args) {
            event.emit(MONITOR_KEY);
            if (typeof oldPopstate === 'function') {
                // @ts-ignore
                return oldPopstate.apply(this, args);
            }
        };
        // hook pushState
        if (win.history && typeof win.history['pushState'] === 'function') {
            const oldPushState = win.history['pushState'];
            const newPushState = function (...args) {
                // @ts-ignore
                oldPushState.apply(this, args);
                if (window.surveyFlag) {
                    clearTimeout(window.surveyFlag);
                }
                setTimeout(() => {
                    event.emit(MONITOR_KEY);
                }, 300);
            };
            win.history['pushState'] = newPushState;
        }
        // hook replaceState
        if (win.history && typeof win.history['replaceState'] === 'function') {
            const oldReplaceState = win.history['replaceState'];
            const newReplaceState = function (...args) {
                // @ts-ignore
                oldReplaceState.apply(this, args);
                event.emit(MONITOR_KEY);
            };
            win.history['replaceState'] = newReplaceState;
        }
        isHiHack = true;
    }
    catch (error) {
        console.warn('[ARMS]] error in hookHistory', error);
    }
    return monitorEvent;
};
